import React from "react";
import ReactDOM from "react-dom";
import { Table, Button, Badge } from "reactstrap";
import FooterPagination from "../../Pagination/FooterPagination";
import { useNavigate, useParams } from "react-router-dom";
import { textRoles } from "../../../constants";
import ViewButton from "../../Buttons/ViewButton";
import UserStatusBadge from "../../Badges/UserStatusBadge";
import DropdownMenuActions from "../../Dropdown/DropdownMenuActions";
import { resentInvitation } from "../../../slices/general/thunk";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";

const EmployerGroupsTable = ({
  data,
  searchParam,
  searchDone,
  paginationProps,
}) => {
  const { id, role } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isNotSearchResult = searchParam && !data.length && searchDone;
  const noData = data.length === 0 && !searchParam;

  const handleViewProfile = (id) => {
    const route = `/employers/${id}`;
    navigate(route);
  };

  const handleRowClick = (userId, event) => {
    const selection = window.getSelection().toString();
    if (!selection) {
      navigate(`/employers/${userId}`);
    }
  };

  const handleResendInvitation = async (userId) => {
    try {
      const response = await dispatch(resentInvitation({ userId }));

      const res = response.payload;

      if (res && !res.error) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Invitation has been resent successfully",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Invitation could not be resent",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Invitation could not be resent",
      });
      console.log(error);
    }
  };

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th scope="col">Company Name</th>
          <th scope="col">Contact</th>
          <th scope="col">Number of Employees</th>
          <th scope="col" className="text-center">
            Status
          </th>
          <th scope="col" className="text-center">
            Manage
          </th>
        </tr>
      </thead>
      <tbody>
        {isNotSearchResult && (
          <tr>
            <td className="text-center" colSpan="12">
              No search results for "{searchParam}"
            </td>
          </tr>
        )}
        {noData ? (
          <tr>
            <td className="text-center" colSpan="12">
              {id && role
                ? `${textRoles[role]} has no Employer Groups yet.`
                : "You have no Employer Groups yet."}
            </td>
          </tr>
        ) : (
          data.map((user, index) => (
            <tr
              key={index}
              onClick={(event) => handleRowClick(user.id, event)}
              className="cursor-pointer"
            >
              <td
              // onClick={() => handleViewProfile(user.id)}
              // className="cursor-pointer text-primary text-hover-underlined fw-semibold"
              >
                {" "}
                {user.companyName || "-"}
              </td>
              <td>{user.email}</td>
              <td>{user.employeesCount || "0"}</td>
              <td className="text-center">
                <UserStatusBadge
                  status={user.firstLogin ? "Active" : "Invited"}
                  color={user.firstLogin ? "success" : "warning"}
                />
              </td>
              <td className="text-center">
                {/* <ViewButton user={user} handleViewProfile={handleViewProfile} /> */}
                <DropdownMenuActions
                  onViewProfile={handleViewProfile}
                  onResendInvitation={handleResendInvitation}
                  item={user}
                  status={user.firstLogin ? "Active" : "Invited"}
                />
              </td>
            </tr>
          ))
        )}
      </tbody>
      {paginationProps.totalItems > 0 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default EmployerGroupsTable;
